<script lang="ts">
  import { onMount } from 'svelte';
  import { unMuteUsers } from '../../api/api';
  import { mutesSubject$, pollMutes } from '../../api/restrictedUsers.api';
  import RestrictedUsers, {
    type RestrictedUser,
  } from './RestrictedUsers.svelte';

  let mutes = $state<RestrictedUser[] | null>(null);

  const lift = async (userIds: string[], issuedBy: string) => {
    await unMuteUsers({ userIds, issuedBy });
    mutesSubject$.next();
  };

  onMount(() => {
    const subscription = pollMutes().subscribe({
      next: (data) =>
        (mutes = data.map(({ mutedAt, ...mute }) => ({
          ...mute,
          issuedAt: mutedAt,
        }))),
      error: (err) => console.error('Mutes subscription error', err),
    });
    return () => subscription.unsubscribe();
  });
</script>

<RestrictedUsers
  users={mutes}
  words={{ noun: 'mute', done: 'muted', undo: 'unmute', undone: 'unmuted' }}
  {lift}
/>
